import {
  useAddTransportationTypeByFactory,
  useDeleteTransportationTypeByFactory,
  useGetTransportationTypeByFactory,
} from "hooks/useFactory";
import styled from "@emotion/styled";
import { Alert, Card, Col, message, Row, Switch, Typography } from "antd";
import { FC, useState } from "react";
import { useAppSelector } from "store";
import { useGetTransportType } from "hooks/useMasterData";

interface SelectShippingTypeProps {}

const SelectShippingType: FC<SelectShippingTypeProps> = () => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: masterTransportType } = useGetTransportType();

  const [loading, setLoading] = useState<boolean>(false);

  const {
    data: selectedData,
    isLoading,
    refetch,
  } = useGetTransportationTypeByFactory(factoryId || "");

  const { mutateAsync: AddSelectTransport, isPending: isPendingAdd } =
    useAddTransportationTypeByFactory();

  const { mutateAsync: DeleteSelectTransport, isPending: isPendingDelete } =
    useDeleteTransportationTypeByFactory();

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Typography.Title level={5}>
                  เลือกประเภทการจัดส่ง
                </Typography.Title>
                <Alert
                  message="กรุณเลือกประเภทการจัดส่งก่อนทำการตั่งค่าค่าส่ง"
                  type="warning"
                  showIcon
                  closable
                />
              </Col>
              <Col span={24}>
                <Row gutter={[16, 16]}>
                  {masterTransportType &&
                    selectedData?.data &&
                    masterTransportType?.map((item) => (
                      <Col span={8} key={item.key}>
                        <Card
                          hoverable
                          style={{ width: "100%", padding: "10px" }}
                          bodyStyle={{ padding: "10px" }}
                        >
                          <Switch
                            disabled={
                              isPendingAdd || isPendingDelete || isLoading || loading
                            }
                            checkedChildren="เปิด"
                            unCheckedChildren="ปิด"
                            loading={
                              isPendingAdd || isPendingDelete || isLoading || loading
                            }
                            defaultChecked={selectedData.data?.some(
                              (selected) => selected.key === item.key
                            )}
                            key={item.key}

                            onChange={ async (checked) => {
                              setLoading(true);
                              const id = selectedData.data?.find(
                                (selected) => selected.key === item.key
                              )?.id;
                             

                              if (
                                selectedData.data?.some(
                                  (selected) => selected.key === item.key
                                ) && !checked
                              ) {
                                await DeleteSelectTransport(
                                  { 
                                    id: id || "",

                                   },
                                  {
                                    onSuccess: (res) => {
                                      if (res.status === "success") {
                                        refetch();
                                        message.success("อัพเดตข้อมูลสำเร็จ");
                                      } else {
                                        message.error(
                                          `อัพเดตข้อมูลไม่สำเร็จ: ${res.error_message}`
                                        );
                                      }
                                    },
                                  }
                                );
                              } else {
                                await AddSelectTransport(
                                  { transport_key: item.key },
                                  {
                                    onSuccess: (res) => {
                                      if (res.status === "success") {
                                        refetch();
                                        message.success("อัพเดตข้อมูลสำเร็จ");
                                      } else {
                                        message.error(
                                          `อัพเดตข้อมูลไม่สำเร็จ: ${res.error_message}`
                                        );
                                      }
                                    },
                                  }
                                );
                              }

                              //delay for loading
                              await new Promise((resolve) => setTimeout(resolve, 3000));

                              setLoading(false);
                            }}
                        
                          />
                          <Typography.Text
                            style={{
                              marginLeft: "10px",
                            }}
                          >
                            {item.name}
                          </Typography.Text>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </Col>
            </Row>
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default SelectShippingType;
const WrapperAll = styled.div`
  padding: 16px 0px 10px 0px;
  background-color: #efefef;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 10px;
`;
